import React from 'react'

import { getProfilePropConfig } from 'features/navigation/navigators/ProfileStackNavigator/getProfilePropConfig'
import { StyledSectionRow } from 'features/profile/components/SectionRowWithPaddingVertical/SectionRowWithPaddingVertical'
import { ChatbotAI } from 'ui/svg/icons/ChatbotAI'

export const ChatbotButton = () => (
  <StyledSectionRow
    key="ChatbotButton"
    title="Poser une question"
    type="navigable"
    navigateTo={getProfilePropConfig('Chatbot')}
    icon={ChatbotAI}
  />
)
